import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

const CZECH_DAY_PHRASE = [
  'v neděli',
  'v pondělí',
  'v úterý',
  've středu',
  've čtvrtek',
  'v pátek',
  'v sobotu',
];

/**
 * @param {Date} start
 * @param {number} businessDays
 * @returns {Date}
 */
function addBusinessDays(start, businessDays) {
  const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  let remaining = Math.max(0, businessDays);

  while (remaining > 0) {
    date.setDate(date.getDate() + 1);
    const weekday = date.getDay();
    if (weekday !== 0 && weekday !== 6) {
      remaining -= 1;
    }
  }

  return date;
}

/**
 * @param {Date} date
 * @returns {string}
 */
function formatCzechDeliveryDate(date) {
  return `${CZECH_DAY_PHRASE[date.getDay()]} ${date.getDate()}. ${date.getMonth() + 1}.`;
}

/**
 * @param {ParentNode} root
 */
function fillDeliveryEta(root = document) {
  root.querySelectorAll('[data-delivery-eta]').forEach((node) => {
    if (!(node instanceof HTMLElement)) return;
    const days = Number(node.dataset.businessDays || '0');
    if (!Number.isFinite(days) || days <= 0) return;
    const eta = addBusinessDays(new Date(), days);
    node.textContent = formatCzechDeliveryDate(eta);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  fillDeliveryEta(document);
});

document.addEventListener(ThemeEvents.cartUpdate, () => {
  // Section HTML may remorph after quantity changes; refresh ETA text.
  requestAnimationFrame(() => fillDeliveryEta(document));
});

class ProductStockInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestRoot = this.closest('.shopify-section, dialog, product-card');
    closestRoot?.addEventListener(ThemeEvents.variantUpdate, this.updateStockInfo);
    fillDeliveryEta(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestRoot = this.closest('.shopify-section, dialog, product-card');
    closestRoot?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockInfo);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateStockInfo = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStockInfo = event.detail.data.html.querySelector(
      `product-stock-info[data-product-id="${this.dataset.productId}"]`
    );

    if (!newStockInfo) return;

    morph(this, newStockInfo, { childrenOnly: true });
    fillDeliveryEta(this);
  };
}

if (!customElements.get('product-stock-info')) {
  customElements.define('product-stock-info', ProductStockInfo);
}
